import { useLocation, useNavigate } from 'react-router-dom'

import {
  apartmentAnalyticsProps,
  type AnalyticsSource,
  trackEvent
} from '@services/livability/analytics'
import type { Apartment, IndexCategory } from '@services/livability/types'
import { userStorage } from '@services/utils/local-storage'

import { getLivabilityBasePath } from './paths'

export function useLikeApartment(
  apartment: Apartment | null | undefined,
  indexCategory: IndexCategory,
  source: AnalyticsSource = 'detail'
) {
  const { pathname } = useLocation()
  const navigate = useNavigate()

  return () => {
    if (!apartment) return

    trackEvent(
      'apartment_liked',
      apartmentAnalyticsProps(apartment, source, indexCategory)
    )

    if (!userStorage.get()) {
      navigate('/login?redirect=/user/application')
      return
    }

    const base = getLivabilityBasePath(pathname) || '/user'
    navigate(`${base}/application`, {
      state: {
        prefillFromApartment: {
          price_month: apartment.price_month,
          area_m2: apartment.area_m2,
          room_count: apartment.room_count,
          location: apartment.location
        }
      }
    })
  }
}
